interface ApplicationDeadlineCardProps {
  startDate?: string | Date;
  endDate?: string | Date;
}

function formatDate(dateStr: string | Date | undefined) {
  if (!dateStr) return "TBD";
  const d = new Date(dateStr);
  return d.toLocaleDateString(undefined, {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

export function ApplicationDeadlineCard({
  startDate,
  endDate,
}: ApplicationDeadlineCardProps) {
  // Hide the entire card if neither date exists
  if (!startDate && !endDate) return null;

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-6">
      <h3 className="text-lg font-semibold text-black mb-4">
        Application Deadline
      </h3>
      <div className="space-y-2">
        {startDate && (
          <div className="flex items-center gap-2">
            <span className="text-sm text-gray-500">Opens</span>
            <span className="text-gray-500">
              {formatDate(startDate)}
            </span>
          </div>
        )}
        {endDate && (
          <div className="flex items-center gap-2">
            <span className="text-sm text-gray-500">Closes</span>
            <span className="text-gray-500">
              {formatDate(endDate)}
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
